//====================================================
//  Initialization Fullscreeen navigation
//====================================================
function fn_components_fullscreen_navigation(){
	if ($( '.navigation' ).length){
		$( '.navigation-trigger').on('click', function(e){
			$(this).closest( '.navigation' ).toggleClass( 'is-collapse' );
			$( 'body' ).toggleClass( 'overflow-hidden' );

			if ($( '.language-dropdown.is-active' ).length){
				$( '.language-dropdown.is-active' ).removeClass( 'is-active' );
			}
			e.preventDefault();
		});
		fn_checkNavigationTrigger();
	}
}

function fn_checkNavigationTrigger(){
	(function($){
		if($( '.navigation' ).hasClass( 'is-collapse' )){
			$( '.navigation' ).removeClass( 'is-collapse' );
			$( 'body' ).removeClass( 'overflow-hidden' );
		}
	})(jQuery);
}